import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import { menu } from '../listas/menu'
import { ContextoDispositivo } from '../contextos/Dispositivo'
import { Icon } from '@iconify/react/dist/iconify.js'
import { ICON_TYPES } from '../constantes/iconos.ts'
import Full from './Menu.jsx'
import logo from '../imagenes/284155446_5051543411565338_4169603858621060659_n.jpg'
import { useNavigate } from 'react-router-dom'



const Header = () => {
    const navigate = useNavigate()
    const [nav, setNav] = useState(false)
    const { dispositivo } = useContext(ContextoDispositivo)
    return (
        <Container>
            <Full activo={nav} cambio={setNav} />
            <Cabecera>
                <Logo onClick={() => navigate('/')}>
                    <img style={{ height: '100%', }} src={logo} alt="logo" />
                </Logo>
                {
                    dispositivo ?
                        <Menu>
                            {menu.map(e => {
                                return (
                                    <Opcion onClick={() => navigate(e.link)} key={e.titulo}>{e.titulo}</Opcion>
                                )
                            })}
                        </Menu> :
                        <button onClick={() => setNav(true)}>
                            <Icon icon={ICON_TYPES.MENU} style={{ fontSize: '36px' }} />
                        </button>
                }

            </Cabecera>
        </Container>

    )
}

const Cabecera = styled.nav`
    padding: 15px;
    z-index: 4;
    position: fixed;
    border-radius: 20px;
    height: 50px;
    width: 90%;
    background-color: #eee;
    border: 1px solid #000;
    box-shadow: 0 4px 10px #000;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const Logo = styled.div`
    cursor: pointer;
    height: 30px;
    width: 30px;
    background-image: ${props => props.src};
    border-radius: 50%;
    overflow: hidden;
`

const Menu = styled.ul`
    margin: 0 15px;
    display: flex;
    gap: 50px;
    justify-content: space-evenly;
    align-items: center;
`

const Opcion = styled.li`
    color: #000;
    cursor: pointer;
`

const Container = styled.header`
    width: 100vw;
    height: 100px;
    background-color: var(--primary);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

`

export default Header